import React, { useState, useRef } from "react";
import axios from "axios";
import "./ProductVerification.css";
import arrow from "../assets/arrow.png";
import logo1 from "../assets/logo-1.png";
import logo2 from "../assets/logo-4.png";
import carimage from "../assets/cars-image.png";
import sucessimg from "../assets/order-confirmed-2.png";
const Product = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    code: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false); // New state to track success

  const codeInputRef = useRef(null);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    setError("");
    setSuccess(false);

    try {
      const response = await axios.post(
        "https://project.ertiqaa-amwaj-aliraq.com.iq/api/check-code",
        formData
      );

      console.log(response.data);

      // Correct condition to check success
      if (response.data.status === "success") {
        setSuccess(true);
      } else {
        setError(response.data.message || "هذا الكود مستخدم من قبل");
        if (codeInputRef.current) {
          codeInputRef.current.focus();
        }
      }
    } catch (err) {
      setError("هذا الكود تم استخدامه مسبقاً");
      if (codeInputRef.current) {
        codeInputRef.current.focus();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="product-page">
      <div className="container">
        <div className="illustration-section row justify-content-between align-items-center">
          {success ? (
            <div className="sucess-part col-lg-6 p-sm-0" data-aos="Zoom-in">
              <a href="https://ertiqaa-amwaj-aliraq.com.iq/" data-aos="flip-down">
                <img src={arrow} alt="arrow" style={{ width: "76px" }} />
              </a>
              <div className="form-section-sucess ">
                <img src={sucessimg} alt="success" className="img-fluid" />
              </div>
            </div>
          ) : (
            <div className="form-section col-lg-6 p-0">
              <a href="https://ertiqaa-amwaj-aliraq.com.iq/" data-aos="fade-down" className="arrow-link">
                <img src={arrow} alt="arrow" style={{ width: "76px" }} />
              </a>
              <div className="form" data-aos="fade-left">
                <h2 className="form-title">تحقق من المنتج</h2>
                <p className="form-subtitle">
                  ادخل السمك ورقم الهاتف الخاص بك، لتحقق سيتم و اكتشف صحة الأكثر
                  من الصفارة
                </p>

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>اسم العميل<span>*</span></label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="اسم العميل"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>رقم الهاتف<span>*</span></label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="رقم الهاتف"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>
                      كود المنتج 
                    <span>*</span></label>
                    <input
                      type="text"
                      name="code"
                      value={formData.code}
                      onChange={handleChange}
                      placeholder="0000-0000"
                      className="product-code-input"
                      required
                      ref={codeInputRef}
                    />
                  </div>
                  {error && <div className="error-message"
                 data-aos="fade-up"
     data-aos-anchor-placement="bottom-bottom"
                  >{error}</div>}
                  <button
                    type="submit"
                    className="verify-button"
                    disabled={loading}
                  >
                    {loading ? "جاري التحقق..." : "تحقق"}
                  </button>
                </form>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="logos-part">
              <img src={logo2} alt="logo-2" />
              <img src={logo1} alt="logo-1" />
            </div>

            <div
              className="image-car-part d-none d-lg-block"
              data-aos="fade-down"
            >
              <img src={carimage} alt="car-image" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
